import { createUseStyles } from 'react-jss';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BackgroundColors } from '@picsart/design-system/foundation/colors';

const useStyles = createUseStyles(
  {
    root: {
      position: 'relative',
      width: '100%',
      backgroundColor: BackgroundColors.base,
      overflow: 'hidden',
      borderRadius: CornerRadius.r8,
    },
    player: { zIndex: 38 },
  },
  { name: 'lazy-video' },
);

export default useStyles;
